import React__default, { forwardRef, useCallback } from 'react';
import PT from 'prop-types';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../../3rdPartyModules/_react-aria/focus/dist/useFocusRing-DPVmdx21.js';
import { u as useTileGroupContext } from '../TileGroupContext-CvSfRsxH.js';
import { D as DEFAULT_TILE_CONTEXT, T as TileContextProvider, a as TileControlContextProvider } from './TileContext-CQYBPDL3.js';
import { C as Container } from './Tile.styles-CjmxHVxB.js';
import { T as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';

const Tile = /*#__PURE__*/forwardRef(({
  direction: tileDirection,
  disabled: tileDisabled,
  label,
  onChange,
  selected: tileSelected,
  taktId,
  taktValue,
  value,
  children,
  ...restProps
}, ref) => {
  const {
    onSelect,
    selectedValues,
    direction: tileGroupDirection,
    disabled: tileGroupDisabled
  } = useTileGroupContext();
  const selected = (selectedValues !== null && selectedValues !== void 0 ? selectedValues : []).findIndex(selectedValue => selectedValue === value) > -1 || tileSelected || DEFAULT_TILE_CONTEXT.selected;
  const direction = tileGroupDirection || tileDirection || DEFAULT_TILE_CONTEXT.direction;
  const disabled = tileGroupDisabled || tileDisabled || DEFAULT_TILE_CONTEXT.disabled;
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  const handleChange = useCallback(event => {
    if (onSelect) {
      onSelect(value, event);
    }
    if (onChange) {
      onChange(event);
    }
  }, [onChange, onSelect, value]);
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('tile')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(Container, {
    $checked: selected,
    $disabled: disabled,
    $direction: direction,
    $focusVisible: isFocusVisible
  }, /*#__PURE__*/React__default.createElement(TileContextProvider, {
    disabled: disabled,
    selected: selected,
    direction: direction
  }, /*#__PURE__*/React__default.createElement(TileControlContextProvider, {
    focusProps: focusProps,
    label: label,
    onChange: handleChange,
    value: value,
    dataTaktAttributes: getDataTaktAttributes({
      taktIdSuffix: 'input'
    }),
    innerRef: ref,
    restProps: restProps
  }, children))));
});
Tile.defaultProps = {
  direction: undefined,
  disabled: false,
  onChange: undefined,
  selected: false
};
Tile.propTypes = {
  /**
   * How header, body and footer are placed.
   */
  direction: PT.oneOf(['column', 'row']),
  /**
   * Set this to true to indicate the Tile is disabled.
   */
  disabled: PT.bool,
  /**
   * Hidden label of the Tile.
   */
  label: PT.string.isRequired,
  /**
   * The function called on input change.
   */
  onChange: PT.func,
  /**
   * Set this to true to indicate the value of the Tile is selected.
   */
  selected: PT.bool,
  /**
   * Value of the Tile.
   */
  value: PT.oneOfType([PT.string, PT.number]).isRequired
};

export { Tile as T };
//# sourceMappingURL=Tile-bJdJvS3C.js.map
